import React, { useState } from 'react';

import CButton from '../button/button';
import CInput from '../input/input';
import CUpload from '../input/upload';
import { Line, Space } from '../utils/utils';

import '../../theme/global.scss';
import { notify } from '../../notifications/notification';
import {
  checkFilesHaveSameType,
  combineFiles,
  handleFileChange,
  initialFile
} from '../../utils/files';
import { TCallbackVoid } from '../../utils/interfaces/interfaces';
import { typesFiles } from '../../types/uploaded-data';

interface IALegislation {
  type: string;
  callback: () => void;
  submit: (
    name: string,
    type: string,
    file: any,
    callback: TCallbackVoid
  ) => void;
}

const AddLegislation = (props: IALegislation) => {
  const [name, setName] = useState('');
  const [file, setFile] = useState(initialFile);

  const handleName = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setName(value);
  };

  const handleFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      if (!checkFilesHaveSameType(event.target.files, typesFiles.pdf)) {
        notify(
          'Unul dintre fișiere nu este potrivit. Trebuie să încărcați fișiere cu extensie .pdf.',
          'info'
        );
        return;
      }
    }
    handleFileChange(event, setFile);
  };

  const handleSubmit = async (event: React.MouseEvent) => {
    /* prevent from reloading */
    event.preventDefault();

    if (name.length > 0 && file.length > 0) {
      /* submit request */
      const filesToUpload = await combineFiles(file, name);
      props.submit(name, props.type, filesToUpload, () => {
        notify('Ați adăugat cu succes un fișier nou.', 'success');
        props.callback();
      });
    } else {
      notify('Nu ați completat toate informațiile!', 'warning');
    }
  };
  return (
    <form>
      <p className='body-dark bold'>Adăugare document</p>
      <Line width={'80px'} />
      <Space vertical={'30px'} />
      <CInput
        label='Nume fișier'
        type='text'
        id='name'
        placeholder='Nume fișier'
        name='name'
        value={name}
        onChange={handleName}
        required
      />
      <CUpload
        label={'Fișier'}
        id='file'
        placeholder='file'
        name='name'
        value={file}
        onChange={handleFile}
        required
      />
      <Space vertical={'30px'} />
      <CButton label='Adaugă' type='submit' onClick={handleSubmit} />
    </form>
  );
};

export default AddLegislation;
